document.addEventListener('DOMContentLoaded', () => {
  let tabletAndBelow = window.matchMedia("(max-width: 768px)");
  if (tabletAndBelow.matches) {
    let categoryButtons = document.querySelectorAll('.line-up__categories__button');
    categoryButtons.forEach(btn => {
      if(btn.textContent.length > 12) btn.textContent = btn.textContent.substring(0, 9) + '...';
    })
  }

  jQuery('.line-up__models-section').not('.slick-initialized').slick({
    "prevArrow": '<button class="slick-prev-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "nextArrow": '<button class="slick-next-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "dots": false,
    "infinite": false,
    "speed": 500,
    "initialSlide": 0,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
       {
        breakpoint: 1536,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 5500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      }
    ]
  });

  /* Atum */
  jQuery('.line-up-atum__models-section').not('.slick-initialized').slick({
    "dots": true,
    "arrows": false,
    "infinite": false,
    "speed": 500,
    "slidesToShow": 4,
    "slidesToScroll": 4,
    "initialSlide": 0,
    responsive: [
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  /*FOUR*/
    jQuery('.line-up-four__models-section').not('.slick-initialized').slick({
    "prevArrow": '<button class="lbx-arrow lbx-arrow-prev slick-arrow" aria-label="Previous" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6"/></svg></button>',
    "nextArrow": '<button class="lbx-arrow lbx-arrow-next slick-arrow" aria-label="Next" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6"/></svg></button>',
    "dots": true,
    "infinite": false,
    "speed": 500,
    "slidesToShow": 4,
    "slidesToScroll": 4,
    "initialSlide": 0,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  jQuery('.line-up__models-section').slick('slickUnfilter');
  jQuery('.line-up__models-section').slick('slickFilter', `.${lineup_ajax_object.selected_category}`);
  
  jQuery('div.line-up__categories__list button').not('.ct-selected').on('click', function () {
    jQuery('div.line-up__categories__list button.ct-selected').removeClass('line-up__categorie-btn');
    jQuery(this).addClass('line-up__categorie-btn ct-selected');
    var filterClass = jQuery(this).data('value');
    jQuery('.line-up__models-section').slick('slickUnfilter');
    jQuery('.line-up__models-section').slick('slickFilter', filterClass);
  });

  jQuery(`div.line-up__categories__list button.ct-selected.ct-${lineup_ajax_object.selected_category}`).on('click', function() {
    jQuery(this).addClass('line-up__categorie-btn');
    jQuery('div.line-up__categories__list button.ct-selected').not(`.ct-${lineup_ajax_object.selected_category}`).removeClass('line-up__categorie-btn');
    var filterClass = jQuery(this).data('value');
    jQuery('.line-up__models-section').slick('slickUnfilter');
    jQuery('.line-up__models-section').slick('slickFilter', filterClass);
  });

  /* -------------------------------------------------------------------------------------------------- */

  /* ATUM */
  jQuery('.line-up-atum__models-section').slick('slickUnfilter');
  jQuery('.line-up-atum__models-section').slick('slickFilter', `.${lineup_ajax_object.selected_category}`);

  jQuery('div.line-up-atum__categories__list button').not('.ct-selected').on('click', function() {
    jQuery('div.line-up-atum__categories__list button.ct-selected').removeClass('font-primary-bold line-up-atum__categorie-btn');
    jQuery(this).addClass('font-primary-bold line-up-atum__categorie-btn ct-selected');
    var filterClass = jQuery(this).data('value');
    jQuery('.line-up-atum__models-section').slick('slickUnfilter');
    jQuery('.line-up-atum__models-section').slick('slickFilter', filterClass);
  });

  jQuery(`div.line-up-atum__categories__list button.ct-selected.ct-${lineup_ajax_object.selected_category}`).on('click', function() {
    jQuery(this).addClass('font-primary-bold line-up-atum__categorie-btn');
    jQuery('div.line-up-atum__categories__list button.ct-selected').not(`.ct-${lineup_ajax_object.selected_category}`).removeClass('font-primary-bold line-up-atum__categorie-btn');
    var filterClass = jQuery(this).data('value');
    jQuery('.line-up-atum__models-section').slick('slickUnfilter');
    jQuery('.line-up-atum__models-section').slick('slickFilter', filterClass);
  });
  /* ------------------------------------------------------------------------------------ */

  /* FOUR */
  function lineupFourSyncArrows() {
    var fourSlick = jQuery('.line-up-four__models-section').slick('getSlick');
    if (!fourSlick || !fourSlick.options) return;
    var showArrows = fourSlick.slideCount > fourSlick.options.slidesToShow;
    if (fourSlick.$prevArrow) fourSlick.$prevArrow.toggle(showArrows);
    if (fourSlick.$nextArrow) fourSlick.$nextArrow.toggle(showArrows);
  }

  jQuery('.line-up-four__models-section').slick('slickUnfilter');
  jQuery('.line-up-four__models-section').slick('slickFilter', `.${lineup_ajax_object.selected_category}`);
  lineupFourSyncArrows();
  
  jQuery('div.line-up-four__categories__list button').not('.ct-selected').on('click', function() {
    jQuery('div.line-up-four__categories__list button.ct-selected').removeClass('underline underline-offset-4 text-primary line-up__categorie-btn');
    jQuery(this).addClass('underline underline-offset-4 text-primary line-up__categorie-btn ct-selected');
    var filterClass = jQuery(this).data('value');
    jQuery('.line-up-four__models-section').slick('slickUnfilter');
    jQuery('.line-up-four__models-section').slick('slickFilter', filterClass);
    lineupFourSyncArrows();
  });

  jQuery(`div.line-up-four__categories__list button.ct-selected.ct-${lineup_ajax_object.selected_category}`).on('click', function() {
    jQuery(this).addClass('underline underline-offset-4 text-primary line-up__categorie-btn');
    jQuery('div.line-up-four__categories__list button.ct-selected').not(`.ct-${lineup_ajax_object.selected_category}`).removeClass('underline underline-offset-4 text-primary line-up__categorie-btn');
    var filterClass = jQuery(this).data('value');
    jQuery('.line-up-four__models-section').slick('slickUnfilter');
    jQuery('.line-up-four__models-section').slick('slickFilter', filterClass);
    lineupFourSyncArrows();
  });

  /* ------------------------------------------------------------------------------------------------------------ */

});